// src/components/blogs/AddBlog.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../redux/slices/blogCategorySlice";
import { addBlog, clearBlogMessages } from "../redux/slices/blogslice";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const AddBlog = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const { categories } = useSelector((state) => state.blogCategory);
    const { success, error, loading } = useSelector((state) => state.blogs);

    const [formData, setFormData] = useState({
        permalink: "",
        blogTitle: "",
        blogDescription: "",
        category: "",
        imageAltText: "",
        metaTitle: "",
        metaDescription: "",
        metaKeywords: ""
    });
    const [blogImage, setBlogImage] = useState(null);

    useEffect(() => {
        dispatch(fetchCategories());
    }, [dispatch]);

    // SHOW SWEET ALERT WHEN success or error changes
    useEffect(() => {
        if (success) {
            Swal.fire({
                icon: "success",
                title: "Success!",
                text: success,
                timer: 2000,
                showConfirmButton: false
            });
            navigate("/all-blogs")
        }

        if (error) {
            Swal.fire({
                icon: "error",
                title: "Error!",
                text: error,
                timer: 2500,
                showConfirmButton: false
            });
        }

        if (success || error) {
            setTimeout(() => {
                dispatch(clearBlogMessages());
            }, 3000);
        }
    }, [success, error, dispatch]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleImageChange = (e) => {
        setBlogImage(e.target.files[0]);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const data = new FormData();
        Object.keys(formData).forEach((key) => {
            data.append(key, formData[key]);
        });
        if (blogImage) {
            data.append("blogImage", blogImage);
        }

        dispatch(addBlog(data));
    };

    return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-header bg-primary text-white">
                    <h6 className="mb-0 text-white">Add New Blog</h6>
                </div>
                <div className="card-body">

                    {/* FORM START */}
                    <form onSubmit={handleSubmit}>
                        {/* Permalink */}
                        <div className="mb-3">
                            <label className="form-label">Permalink *</label>
                            <input
                                type="text"
                                name="permalink"
                                value={formData.permalink}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="unique-blog-url"
                                required
                            />
                        </div>

                        {/* Title */}
                        <div className="mb-3">
                            <label className="form-label">Blog Title *</label>
                            <input
                                type="text"
                                name="blogTitle"
                                value={formData.blogTitle}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Enter blog title"
                                required
                            />
                        </div>

                        {/* Blog Image + Alt Text */}
                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label">Blog Image *</label>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                    className="form-control"
                                    required
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Image Alt Text</label>
                                <input
                                    type="text"
                                    name="imageAltText"
                                    value={formData.imageAltText}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Describe image"
                                />
                            </div>

                            {/* Category */}
                            <div className="col-md-4">
                                <label className="form-label">Category *</label>
                                <select
                                    name="category"
                                    value={formData.category}
                                    onChange={handleChange}
                                    className="form-select"
                                    required
                                >
                                    <option value="">Select Category</option>
                                    {categories?.map((cat) => (
                                        <option key={cat._id} value={cat._id}>
                                            {cat.categoryName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* CKEditor */}
                        <div className="mb-3">
                            <label className="form-label">Blog Description *</label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={formData.blogDescription}
                                onChange={(event, editor) =>
                                    setFormData({
                                        ...formData,
                                        blogDescription: editor.getData()
                                    })
                                }
                            />
                        </div>

                        {/* Meta Fields */}
                        <div className="mb-3">
                            <label className="form-label">Meta Title</label>
                            <input
                                type="text"
                                name="metaTitle"
                                value={formData.metaTitle}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Meta Description</label>
                            <textarea
                                name="metaDescription"
                                value={formData.metaDescription}
                                onChange={handleChange}
                                className="form-control"
                                rows="2"
                            ></textarea>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Meta Keywords</label>
                            <input
                                type="text"
                                name="metaKeywords"
                                value={formData.metaKeywords}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="keyword1, keyword2"
                            />
                        </div>

                        {/* Button */}
                        <button
                            type="submit"
                            className="btn btn-success"
                            disabled={loading}
                        >
                            {loading ? "Saving..." : "Add Blog"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddBlog;
